import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { withStyles } from "@material-ui/core/styles";
import { Link,useLocation,useHistory } from "react-router-dom";
import { Button, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import CssBaseline from "@material-ui/core/CssBaseline";
import SidebarLinksAfterlogin from "components/Header/SidebarLinksAfterlogin.js";
import HeaderDashboard from "components/Header/HeaderDashboard";
import WalletModal from "components/WalletModal.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import Web3 from 'web3';
import '@metamask/legacy-web3'
import BEP721 from '../ABI/BEP721.json'
import BEP1155 from '../ABI/BEP1155.json';
import userContract721 from '../ABI/BEP1155.json';
import Datetime from 'react-datetime';
import moment from "moment"
import "react-datetime/css/react-datetime.css";
import {
  GetCategoryAction,
  CreateTokenValidationAction,
  CreateCollectionValidationAction,
  TokenAddItemAction,
  TokenAddOwnerAction,
  TokenCount_Get_Action,
  ipfsImageHashGet,
  ipfsmetadatafunciton,
  iswhitelist
} from '../actions/v1/token';

import {
  getCurAddr
} from '../actions/v1/User';
import axios from 'axios';
import config from '../lib/config';
import { toast } from 'react-toastify';
import ConnectWallet from './separate/Connect-Wallet';
import Select from "react-select";

toast.configure();
let toasterOption      = config.toasterOption;
const singleContract   = config.singleContract;
const multipleContract = config.multipleContract;
const SingleType       = config.singleType;
const MultipleType     = config.multipleType;
const Back_URL         = config.Back_URL;
const drawerWidth      = 240;

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

const styles = theme => ({
  root: {
    display: "flex"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonIconClosed: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    transform: "rotate(0deg)"
  },
  menuButtonIconOpen: {
    transition: theme.transitions.create(["transform"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    transform: "rotate(180deg)"
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: "hidden",
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 7.5 + 1
    }
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing.unit,
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3
  },
  grow: {
    flexGrow: 1
  }
});

const CreateSingle =(props) => {

  var pathVal     = '';
  const location  = useLocation();
  if(location.pathname) {
    if(location.pathname.split('/').length >= 2) {
      pathVal = location.pathname.split('/')[1];
    }
  }
  console.log("pathval",pathVal)
  const [open,setOpen] =useState(true)
   const [anchorEl,setAnchorEl] =useState(null)
  const handleDrawerOpen = () => {
    console.log("data---------------")
    setOpen(!open)
  };

  const handleDrawerClose = () => {
        setOpen(true)
  };

  const handleMenu = event => {
    console.log("----event",event)
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
setAnchorEl(null);
  };
  const history = useHistory()
  const [startDate, setStartDate]                    = useState(new Date());
  const [endDate, setEndDate]                        = useState(new Date());
  const [WalletConnected, Set_WalletConnected]       = useState('false');
  const [UserAccountAddr, Set_UserAccountAddr]       = useState('');
  const [UserAccountBal, Set_UserAccountBal]         = useState(0);
  const [AddressUserDetails, Set_AddressUserDetails] = useState({});
  const [Accounts, Set_Accounts]                     = useState('');
  const [MyItemAccountAddr, Set_MyItemAccountAddr]   = useState('');
  const [ipfshash, setIpfsHash]                      = useState("")
  const [ipfshashurl, setipfshashurl]                = useState('');
  const [TokenPriceTot, setTokenPriceTot]            = useState(0);
  const [location_pathname, Set_location_pathname]     = useState(pathVal);
  var CollectibleType_val                              = (location_pathname == 'create-single') ? SingleType : MultipleType;
  var ContractAddressUser_val                          = (location_pathname == 'create-single') ? config.singleContract : config.multipleContract;
  const [whitelist,setwhitelist]                       = useState(false);
  const [CollectibleType, Set_CollectibleType]         = useState(CollectibleType_val);
  const [ContractAddressUser, set_ContractAddressUser] = useState(ContractAddressUser_val);
  const [FormSubmitUserClicked, Set_FormSubmitUserClicked] = useState(false);

  const [TokenCollection, setTokenCollection]          = useState({
    addr:'',
    img:'site.png',
    name:'Hentai Holiday'
  });
  const [TokenOwner, setTokenowner]                    = useState({
    addr:'',
    img:'',
    name:''
  });
  const [TokenCreater, setTokenCreater]                = useState({
    addr:'',
    img:'',
    name:''
  });
  var myDate                               = new Date();
  var newdat                               = myDate.setDate(myDate.getDate() + parseInt(1));
  var initialEnd                           = new Date(newdat);
  const [StartDate, Set_StartDate]         = useState('Right after listing');
  const [EndDate, Set_EndDate]             = useState('1 Day');
  const [MintHashVal, Set_MintHashVal]     = useState('');
  const [TokenQuantity, Set_TokenQuantity] = useState(1);
  const [TokenBid, setTokenBid]            = useState(true);
  const [MinimumBid, Set_MinimumBid]       = useState(0);
  const [Clocktime, set_Clocktime]         = useState('');
  const [EndClocktime, set_EndClocktime]   = useState(initialEnd);
  const [UnLockcontent, Set_UnLockcontent] = useState("");
  const [Unlockoncepurchased, Set_Unlockoncepurchased] = useState(false);

  const [SingleContractAddressAdmin, set_SingleContractAddressAdmin]     = useState(config.singleContract);
  const [MultipleContractAddressAdmin, set_MultipleContractAddressAdmin] = useState(config.multipleContract);
  const [TokenCount, Set_TokenCount]                                     = useState(0);
  const [ApproveCallStatus, setApproveCallStatus]   = useState('init');
  const [MintCallStatus, setMintCallStatus]         = useState('init');
  const [SignCallStatus, setSignCallStatus]         = useState('init');
  const [SignLockCallStatus, setSignLockCallStatus] = useState('init');
  const [CollectionStatus, setCollectionStatus]     = useState('init');
  const [TokenType, setTokenType]                   = useState('Single');
  const [ValidateError, setValidateError]           = useState({TokenPrice:''});
  const [PutOnSale, setPutOnSale]                   = useState(false);
  const [PutOnSaleType, setPutOnSaleType]           = useState('');
  const [TokenCategory, setTokenCategory]           = useState('');
  const [CategoryOption, setCategoryOption]         = useState(0);
  const [TokenPrice, setTokenPrice]                 = useState(0);
  const [YouWillGet, Set_YouWillGet]                = useState(0);
  const [TokenName, setTokenName]                   = useState('');
  const [TokenDescription, setTokenDescription]     = useState('');
  const [TokenRoyalities, setTokenRoyalities]       = useState(10);
  const [TokenProperties, setTokenProperties]       = useState('');
  const [TokenFile, setTokenFile]                   = useState("");
  const [TokenFilePreReader, setTokenFilePreReader] = useState("");
  const [TokenFilePreUrl, setTokenFilePreUrl]       = useState("");
  const [ipfsimg, setIpfsImg]                       = useState(null)
  const [CollectionFile, setCollectionFile]         = useState("");
  const [CollectionFilePreReader, setCollectionFilePreReader] = useState("");
  const [CollectionFilePreUrl, setCollectionFilePreUrl]       = useState("");
  const [Dispname, setDispname]                     = useState('');
  const [Symbol, setSymbol]                         = useState('');
  const [Colsdescription, setColsdescription]       = useState('');
  const [Shorturl, setShorturl]                     = useState('');
  const [digitalContract,setdigitalContract]        = useState('');
  const [newcollectionStatus,setnewCollectionStatus]= useState(0);
  const [ipfsmetatag,set_ipfsmetatag]               = useState('');
  const [usdval,setusd]                             = useState(0);
  const [biddingtoken, set_biddingtoken]            = useState("ETH")
  const [tokenWill, setTokenWill]                   = useState(0);
  const [Categorylist, setCategorylist]             = useState([]);
  const [servicefee, setservicefee]                 = useState(0);

  useEffect(() => {
    getfee();
   }, [
     FormSubmitUserClicked,
     StartDate,
     EndDate,
     TokenQuantity,
     TokenBid,
     MinimumBid,
     Clocktime,
     EndClocktime,
     UnLockcontent,
     Unlockoncepurchased,
     PutOnSale,
     PutOnSaleType,
     TokenCategory,
     TokenPrice,
     TokenName,
     TokenDescription,
     TokenRoyalities,
     TokenProperties,
     TokenFilePreUrl,
     CollectionFile,
     CollectionFilePreUrl,
     ipfsimg,
   ]);

   const price = [
    { value: config.currencySymbol, label: config.currencySymbol },
    { value: config.tokenSymbol, label: config.tokenSymbol }
  ]
  
  const bidprice = [
    { value: config.qualTokenSymbol, label: config.qualTokenSymbol },
    { value: config.tokenSymbol, label: config.tokenSymbol }
  ]

   async function getUsd(){
    await axios.get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
          .then(async (response2) => {
           console.log(response2.data.USD,"===================3")
           setusd(response2.data.USD)
      })
  }

   async function GetCategoryCall() {
     var resp = await GetCategoryAction()
     if (resp && resp.data && resp.data.list) {
       var CategoryOption = [];
       if(resp && resp.data && resp.data.list && resp.data.list.length>0){
       resp.data.list.map((item) => {
        setCategorylist(resp.data.list);
         CategoryOption.push({
           name:'TokenCategory',
           value: item._id,
           label: item.name
         })
       })
       setCategoryOption(CategoryOption)

     }
     }
   }
   const changePutOnSaleType = (type) => {
    setPutOnSaleType(type);
    if (type=="FixedPrice") {
      Set_MinimumBid("")
      set_biddingtoken(config.currencySymbol)
    }else if (type="TimedAuction") {
      setTokenPrice("")
      set_biddingtoken(config.qualTokenSymbol)
    }else{
      Set_MinimumBid("")
      setTokenPrice("")
      set_biddingtoken(config.qualTokenSymbol)
    }
  };
 
   const CheckedChange = (e) => {
     if(e && e.target && e.target.name) {
 
       if(e.target.name == 'putonsale') {
         if (PutOnSale == false) {
           setPutOnSale(true);
           if(PutOnSaleType == '') {
             setPutOnSaleType('FixedPrice')
           }
         }
         else {
           setPutOnSale(false);
         }
       }
       else if(e.target.name == 'unlockoncepurchased'){
         if (Unlockoncepurchased == false) {
           Set_Unlockoncepurchased(true);
         }
         else {
           Set_Unlockoncepurchased(false);
           Set_UnLockcontent("")
         }
       }
     }
   };
   const selectFileChange = (e) => {
     var validExtensions = ["png", 'gif', 'webp', 'mp4', 'mp3']; //array of valid extensions
     if(e.target && e.target.files) {
       var reader = new FileReader()
       var file = e.target.files[0];
       console.log("onchange_file : ", file);
       var fileName = file.name;
       var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
       if ($.inArray(fileNameExt, validExtensions) == -1) {
         toast.error("Only these file types are accepted : "+validExtensions.join(', '), toasterOption);
         $("input[name='image']").val("");
         return false;
       }
       else {
         const fileSize = file.size / 1024 / 1024;
         if (fileSize > 30) {
           toast.error("File size exceeds 30 MB", toasterOption);
           $("input[name='image']").val("");
           return false;
         } else {
           setTokenFile(file);
           var url = reader.readAsDataURL(file);
           reader.onloadend = function (e) {
             if(reader.result) {
               console.log('reader.result', reader.result);
               setTokenFilePreReader(reader.result);
             }
           }.bind(this);
           setTokenFilePreUrl(e.target.value);
         }
       }
     }
   }
   const selectcolsFileChange = (e) => {
     var validExtensions = ['gif',]; 
     if(e.target && e.target.files) {
       var reader = new FileReader()
       var file = e.target.files[0];
       console.log("onchange_file : ", file);
       var fileName = file.name;
       var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
       if ($.inArray(fileNameExt, validExtensions) == -1) {
         toast.error("Only these file types are accepted : "+validExtensions.join(', '), toasterOption);
         $("input[name='file']").val("");
         return false;
       }
       else {
         const fileSize = file.size / 1024 / 1024;
         if (fileSize > 30) {
           toast.error("File size exceeds 30 MB", toasterOption);
           $("input[name='file']").val("");
           return false;
         } else {
           setCollectionFile(file);
           var url = reader.readAsDataURL(file);
           reader.onloadend = function (e) {
             if(reader.result) {
               console.log('reader.result', reader.result);
               setCollectionFilePreReader(reader.result);
             }
           }.bind(this);
           setCollectionFilePreUrl(e.target.value);
         }
       }
     }
   }
   const selectChange = (e) => {
    console.log('selectChange',e)
    if(e && e.name && e.label && e.value) {
      switch(e.name) {
        case 'TokenCategory1':
          setTokenCategory(e);
          break;
        default:
      }
    }
  }
   function handleChange(e) {
    if(e && e.target && e.target.value) {
      console.log("handleChange",e.target.value)
      setTokenCategory(e.target.value);
// alert(e.target.value)
      // switch(e.target.value) {
      //   case 'TokenCategory':
      //     setTokenCategory(e.target.value);
      //     break;
      //   default:
      // }
    }

   }

   async function getfee(){
    var provider = window.ethereum;
     var web3 = new Web3(provider);
     console.log(location_pathname,ContractAddressUser,"==================================")
     if(location_pathname=="create-single"){
      console.log("======================iinjinnnni")
      var nftContract = new web3.eth.Contract(BEP721,ContractAddressUser);
      if(biddingtoken==config.currencySymbol){
        var fee = await nftContract.methods.getServiceFee().call();
      } else if(biddingtoken==config.tokenSymbol){
        var fee = await nftContract.methods.getValobitdxFee().call();
      }
      else{
        var fee = await nftContract.methods.getServiceFee().call();
      }
     }else{
      var nftContract = new web3.eth.Contract(BEP1155,ContractAddressUser);
      if(biddingtoken==config.currencySymbol){
        var fee = await nftContract.methods.getServiceFee().call();
      } else if(biddingtoken==config.tokenSymbol){
        var fee = await nftContract.methods.getValobitdxFee().call();
      }
      else{
        var fee = await nftContract.methods.getServiceFee().call();
      }
     }
     fee= fee/config.decimalvalues
     console.log(fee,"===============fee")
     setservicefee(fee)
   }
 
   const PriceCalculate = async (data={}) => {
    try{
      var provider = window.ethereum;
      var web3 = new Web3(provider);
      var price = (typeof data.price != 'undefined') ? data.price : TokenPrice;
      var weii = await web3.utils.toWei((price).toString()) 
      if(location_pathname=="create-single"){
        var nftContract = new web3.eth.Contract(BEP721,ContractAddressUser);
        if(biddingtoken==config.currencySymbol){
          var fee = await nftContract.methods.getServiceFee().call();
        } else if(biddingtoken==config.tokenSymbol){
          var fee = await nftContract.methods.getValobitdxFee().call();
        }
        else{
          var fee = await nftContract.methods.getServiceFee().call();
        }
      }else{
       var nftContract = new web3.eth.Contract(BEP1155,ContractAddressUser);
       if(biddingtoken==config.currencySymbol){
        var fee = await nftContract.methods.getServiceFee().call();
      } else if(biddingtoken==config.tokenSymbol){
        var fee = await nftContract.methods.getValobitdxFee().call();
      }
      else{
        var fee = await nftContract.methods.getServiceFee().call();
      }
      }
      var per = (weii * fee) / 1e20;
      var mulWei = parseFloat(weii - per);
      Set_YouWillGet((mulWei / config.decimalvalues).toFixed(config.toFixed));
    }catch(err){}
  }
   const collectioninputChange = (e) => {
     if(e && e.target && typeof e.target.value != 'undefined' && e.target.name) {
       var value = e.target.value;
       switch(e.target.name) {
         case 'Dispname':
           setDispname(value);
         break;
         case 'Symbol':
         setSymbol(value);
         break;
         case 'Colsdescription':
           setColsdescription(value);
           break;
           case 'Symbol':
             setShorturl(value);
             break;
       default:
       }
     }
   }
   const onKeyUp = (e) => {
     var charCode = e.keyCode;
     if((charCode>47 && charCode <58) || (charCode>95 && charCode <106)){
       var ValidateError = {};
       setValidateError(ValidateError);
     }else{
       var ValidateError = {};
       ValidateError.TokenQuantity = '"Quantity" must be a number';
       Set_TokenQuantity("");
       setValidateError(ValidateError);
     }
   }
   const inputChange = async (e) => {
     var provider = window.ethereum;
     var web3 = new Web3(provider);
     var fee = servicefee 
     if(e && e.target && typeof e.target.value != 'undefined' && e.target.name) {
       var value = e.target.value;
       if(e.target.value=="TokenPrice"){
         console.log("================hiiiimmememememem")
         var weii = await web3.utils.toWei((value).toString()) 
       }  
       console.log("Enter Valid price",value, isNaN(value),parseFloat(value))
       switch(e.target.name) {
         case 'TokenPrice':
           if(value != '' && isNaN(value) == false && value > 0) {
             setTokenPrice(value);
             PriceCalculate({price:value});
             ValidateError.TokenPrice = '';
             setValidateError(ValidateError);
             
             var per = (weii * fee) / 100;
             var reader = new youWillPay(biddingtoken, value)
 
             setTokenPriceTot(parseFloat((weii - per) / config.decimalvalues).toFixed(config.toFixed));
 
           } 
           else {
             ValidateError.TokenPrice = 'Enter Valid price';
             setValidateError(ValidateError);
             setTokenPrice('0');
             PriceCalculate({price:0});
           }
           break;
         case 'TokenName':
           setTokenName(value);
           break;
         case 'TokenDescription':
           setTokenDescription(value);
           break;
         case 'TokenRoyalities':
           setTokenRoyalities(value);
           break;
         case 'TokenProperties':
           setTokenProperties(value);
           break;
         case 'UnLockcontent':
           Set_UnLockcontent(value);
           break;
         case 'MinimumBid':
           Set_MinimumBid(value);
           break;
         case 'TokenQuantity':
           Set_TokenQuantity(value);
           break;
         default:
       }
     }
   }
 
   useEffect(() => {
    getUsd()
    getwhitelist()
   }, [])

   async function getwhitelist() {
     var web3 = new Web3(window.ethereum);
     var currAddr = window.web3.eth.defaultAccount;

     var data = {
      address : currAddr
     }
     let whitedetail = await iswhitelist(data)
     console.log(whitedetail,"========================WhiteList")
     if(whitedetail && whitedetail.data && whitedetail.data.data && whitedetail.data.data.address){
      setwhitelist(true)
     }else{
      setwhitelist(false)
     }

   }
 
   async function ApproveCall() {
     if (!window.ethereum) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
       return false;
     }
     var web3 = new Web3(window.ethereum);
     var currAddr = window.web3.eth.defaultAccount;
     if (!currAddr) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
       return false;
     }
 
     const singleContract    = new web3.eth.Contract(BEP721, config.singleContract);
     const multipleContract  = new web3.eth.Contract(BEP1155, ContractAddressUser);
     const CoursetroContract = CollectibleType == '721' ? singleContract : multipleContract
     setApproveCallStatus('processing');
     await CoursetroContract.methods.setApproval(
      CollectibleType == '721' ?config.singleContract:config.multipleContract,
       true
     ).send({
       from: Accounts
     })
     .then(async (result) => {
      console.log(result,"===================approvestatus")
      if (result && result.status && result.status==true) {
       var tokenid = (result && result.events && result.events.Approve
         && result.events.Approve.returnValues
         && result.events.Approve.returnValues.token_id)?result.events.Approve.returnValues.token_id:0;
       Set_TokenCount(tokenid)
       var senddata={
         Image: TokenFile,
       }
       var ipfsimghashget=await ipfsImageHashGet(senddata);
       if(ipfsimghashget.data!==undefined){
         if(ipfsimghashget.data.ipfsval!=""){
         setIpfsHash(ipfsimghashget.data.ipfsval)
         setipfshashurl(`${config.IPFS_IMG}/${ipfsimghashget.data.ipfsval}`)
         }
         var newobj={
           name:TokenName,
           image:config.IPFS_IMG+"/"+ipfsimghashget.data.ipfsval,
         }
         var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);
         
         if (ipfsmetatagVal.data !== undefined) {
           if (ipfsmetatagVal.data.ipfsval != "") {
             var ipfsurl=ipfsmetatagVal.data.ipfsval
             set_ipfsmetatag(`${config.IPFS_IMG}/${ipfsurl}`)
           }
         }
       }
 
       toast.success("Approve Successfully", toasterOption);
       setApproveCallStatus('done');
     }else{
      console.log("------------------------inelese")
      toast.error("Approve failed", toasterOption);
       setApproveCallStatus('tryagain');
     }
     })
     .catch((error) => {
      console.log("------------------------inelese111111111")
       toast.error("Approve failed", toasterOption);
       setApproveCallStatus('tryagain');
     })
   }
 
   async function MintCall() {

    if (!window.ethereum) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }
    var web3 = new Web3(window.ethereum);
    var currAddr = window.web3.eth.defaultAccount;
    var CurrAddr = window.web3.eth.defaultAccount;
    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    const singleContract = new web3.eth.Contract(BEP721, ContractAddressUser);
    const multipleContract = new web3.eth.Contract(BEP1155, ContractAddressUser);
    const CoursetroContract = CollectibleType == '721' ? singleContract : multipleContract

    const Digits = config.decimalvalues;
    // const TokenPriceInStr =await web3.utils.toWei((TokenPrice).toString()) 
    const TokenPriceInStr = (TokenPrice * Digits).toString();

    setMintCallStatus('processing');
 if(CollectibleType=="721"){
  await CoursetroContract.methods.mint(
    TokenCount,
    TokenName,
    ipfshashurl,
    ipfsmetatag,
    TokenPriceInStr,
    TokenQuantity,
    TokenRoyalities
  )
  .send({ from: Accounts })
  .then(async (result) => {
    var transactionHash = '';
    if(result && result.transactionHash ){
    if(result.transactionHash) {
      transactionHash = result.transactionHash;
    }
    else {
      transactionHash = result;
    }
    console.log('result', result);
    Set_MintHashVal(transactionHash);
      toast.success("Your Token Added Successfully", toasterOption);
        var Status = "true";
        
        var TokenAddItemPayload = {
          Image: TokenFile,
          ipfsimage:ipfshash,
          Name: TokenName,
          Count: TokenCount,
          Description: TokenDescription,
          Price: TokenPrice,
          Royalities: TokenRoyalities,
          Category_label: TokenCategory,
          Bid: TokenBid,
          Properties: TokenProperties,
          Owner: CurrAddr,
          Creator: CurrAddr,
          CategoryId: TokenCategory,
          Quantity: TokenQuantity,
          Balance: TokenQuantity,
          ContractAddress: ContractAddressUser,
          Status: Status,
          HashValue: transactionHash,
          Type: CollectibleType,
          MinimumBid: 0,
          Clocktime: '',
          EndClocktime: '',
          UnLockcontent: '',
          PutOnSale:PutOnSale,
          PutOnSaleType:PutOnSaleType,
          biddingtoken: biddingtoken,

        };
        console.log(TokenAddItemPayload,"=================================infront")
        if(Unlockoncepurchased == true) {
          TokenAddItemPayload.UnLockcontent = UnLockcontent;
        }

        if(PutOnSale==true) {
          if(PutOnSaleType == 'FixedPrice') {
            TokenAddItemPayload.Price = TokenPrice;
          }
          else if(PutOnSaleType == 'TimedAuction') {
            TokenAddItemPayload.MinimumBid = MinimumBid;
            TokenAddItemPayload.Clocktime = Clocktime;
            TokenAddItemPayload.EndClocktime = EndClocktime;
            TokenAddItemPayload.Price = 0;
          }
        }
        await TokenAddItemAction(TokenAddItemPayload);
        // if(CollectionStatus==1){
        //   ContractAddressUser=digitalContract
        // }else{
        //   ContractAddressUser=ContractAddressUser
        //   }
        var TokenAddOwnerPayload = {
          'Count': TokenCount,
          'Price': TokenPrice,
          'Owner': CurrAddr,
          'Balance': TokenQuantity,
          'Quantity': TokenQuantity,
          'ContractAddress': ContractAddressUser,
          'Type': CollectibleType,
          HashValue: transactionHash,
          biddingtoken: biddingtoken,
          Status: Status,
        };
        if(PutOnSaleType == 'FixedPrice') {
          TokenAddOwnerPayload.Price = TokenPrice;
        }
        await TokenAddOwnerAction(TokenAddOwnerPayload);
        setMintCallStatus('done');
    }else{
      toast.error("Mint Failed", toasterOption);
      setMintCallStatus('tryagain');
    }
  })
  .catch((error) => {
    toast.error("Mint Failed", toasterOption);
    setMintCallStatus('tryagain');
  })
 }else{
  await CoursetroContract.methods.mint(
    TokenCount,
    TokenPriceInStr,
    TokenRoyalities,
    TokenQuantity,
    TokenName,
    ipfshashurl,
    ipfsmetatag,
  )
  .send({ from: Accounts })
  .then(async (result) => {
    if(result && result.transactionHash){
    var transactionHash = '';
    if(result.transactionHash) {
      transactionHash = result.transactionHash;
    }
    else {
      transactionHash = result;
    }
    console.log('result', result);
    Set_MintHashVal(transactionHash);
    // setTimeout(() => {
      toast.success("Your Token Added Successfully", toasterOption);
      // web3.eth.getTransactionReceipt(transactionHash, async function (e, data) {
        // var Status = "";
        // console.log('mint rep : ', e, data);
        // if (data == null) {
        //   Status = "pending";
        // }
        // else if (data.status == '0x0') {
        //   Status = "false";
        // }
        // else {
        //   Status = "true";
        // }
        // alert(CollectionStatus)
        var Status = "true";
        
        // if(newcollectionStatus==1){
        //   ContractAddressUser=digitalContract
        // }else{
        //   ContractAddressUser=ContractAddressUser
        //   }
        var TokenAddItemPayload = {
          Image: TokenFile,
          ipfsimage:ipfshash,
          Name: TokenName,
          Count: TokenCount,
          Description: TokenDescription,
          Price: TokenPrice,
          Royalities: TokenRoyalities,
          Category_label: TokenCategory,
          Bid: TokenBid,
          Properties: TokenProperties,
          Owner: CurrAddr,
          Creator: CurrAddr,
          CategoryId: TokenCategory,
          Quantity: TokenQuantity,
          Balance: TokenQuantity,
          ContractAddress: ContractAddressUser,
          Status: Status,
          HashValue: transactionHash,
          Type: CollectibleType,
          MinimumBid: 0,
          Clocktime: '',
          EndClocktime: '',
          UnLockcontent: '',
          PutOnSale:PutOnSale,
          PutOnSaleType:PutOnSaleType,
          biddingtoken:biddingtoken
        };
        console.log(TokenAddItemPayload,"=================================infront")
        if(Unlockoncepurchased == true) {
          TokenAddItemPayload.UnLockcontent = UnLockcontent;
        }

        if(PutOnSale==true) {
          if(PutOnSaleType == 'FixedPrice') {
            TokenAddItemPayload.Price = TokenPrice;
          }
          else if(PutOnSaleType == 'TimedAuction') {
            TokenAddItemPayload.MinimumBid = MinimumBid;
            TokenAddItemPayload.Clocktime = Clocktime;
            TokenAddItemPayload.EndClocktime = EndClocktime;
            TokenAddItemPayload.Price = 0;
          }
        }
        await TokenAddItemAction(TokenAddItemPayload);
        // if(CollectionStatus==1){
        //   ContractAddressUser=digitalContract
        // }else{
        //   ContractAddressUser=ContractAddressUser
        //   }
        var TokenAddOwnerPayload = {
          'Count': TokenCount,
          'Price': TokenPrice,
          'Owner': CurrAddr,
          'Balance': TokenQuantity,
          'Quantity': TokenQuantity,
          'ContractAddress': ContractAddressUser,
          'Type': CollectibleType,
          HashValue: transactionHash,
          biddingtoken:biddingtoken,
          Status: Status,
        };
        if(PutOnSaleType == 'FixedPrice') {
          TokenAddOwnerPayload.Price = TokenPrice;
        }
        await TokenAddOwnerAction(TokenAddOwnerPayload);
        setMintCallStatus('done');
      }else{
        toast.error("Mint Failed", toasterOption);
       setMintCallStatus('tryagain');
      }
  })
  .catch((error) => {
    toast.error("Mint Failed", toasterOption);
    setMintCallStatus('tryagain');
  })
 }
   
  }
   async function SignCall() {
     if (!window.ethereum) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
     }
     var web3 = new Web3(window.ethereum);
     var currAddr = window.web3.eth.defaultAccount;
     if (!currAddr) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
     }
 
     setSignCallStatus('processing');
     web3.eth.personal.sign("Sign Sell Order", currAddr)
     .then(async (result) => {
       toast.success("Sign Successfully", toasterOption);
       setSignCallStatus('done');
     })
     .catch(() => {
       toast.error("Sign Failed", toasterOption);
       setSignCallStatus('tryagain');
     })
   }
 
   async function SignLockCall() {
     if (!window.ethereum) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
     }
     var web3 = new Web3(window.ethereum);
     var currAddr = window.web3.eth.defaultAccount;
     if (!currAddr) {
       toast.warning("OOPS!..connect Your Wallet", toasterOption);
     }
 
     setSignLockCallStatus('processing');
     web3.eth.personal.sign("Sign Lock Order", currAddr)
     .then(async (result) => {
       toast.success("Sign Lock Order Successfully", toasterOption);
       setSignLockCallStatus('done');
       setTimeout(() => window.$('#create_item_modal').modal('hide'), 600);
       setTimeout(() => history.push("/nft"), 1200);
     })
     .catch(() => {
       toast.error("Sign Failed", toasterOption);
       setSignLockCallStatus('tryagain');
     })
   }
 
   async function CreateCollectionValidation(chk){
     if (chk) {
       var ValidateError = {};
       if(CollectionFilePreUrl == '') {
         ValidateError.CollectionFilePreUrl = '"File" is required';
       }
       if(Dispname == '') {
         ValidateError.Dispname = '"Display Name" is not allowed to be empty';
       }
       if(Symbol == '') {
         ValidateError.Symbol = '"Symbol" is not allowed to be empty';
       }
       setValidateError(ValidateError);
         return ValidateError;
     }else {
       return {};
     }
   }
 
   async function CreateItemValidation(chk) {
     if(chk) {
       var ValidateError = {};
       if(PutOnSaleType=="TimedAuction") {
         var currDate = new Date();
         var sDate = new Date(Clocktime)
         if(StartDate=="Right after listing"){
           set_Clocktime(currDate);
           sDate = currDate;
         }
 
         var startDate = new Date(Clocktime)
         var eDate = new Date(EndClocktime);
         startDate.setSeconds(0);
         eDate.setSeconds(0);
         if(new Date(currDate) > new Date(sDate)){
           ValidateError.StartDate = 'Start date & Time must be greater than now';
         } 
   
         if(Date.parse(startDate) >= Date.parse(eDate)){
           ValidateError.EndDate = '"End date" & Time must be greater than start date and Time';
         }
       }
     
       if(TokenName == '') {
         ValidateError.TokenName = '"Name" is not allowed to be empty';
       }
        console.log("===================token",TokenRoyalities)
       if(TokenRoyalities == '') {
         ValidateError.TokenRoyalities = '"Royalties" is not allowed to be empty';
       }
       else if(isNaN(TokenRoyalities) == true) {
         ValidateError.TokenRoyalities = '"Royalties" must be a number';
       }
       else if(TokenRoyalities > 50) {
         ValidateError.TokenRoyalities = '"Royalties" must be less than or equal to 50';
       }
       if(TokenFilePreUrl == '') {
         ValidateError.TokenFilePreUrl = '"File" is required';
       }
 
       if(Unlockoncepurchased && UnLockcontent == '') {
         ValidateError.UnLockcontent = '"Locked content" is required';
       }
 
       if(PutOnSale == true && PutOnSaleType=='FixedPrice') {
         if(TokenPrice == '' || isNaN(TokenPrice) == true && TokenPrice == 0) {
           ValidateError.TokenPrice = '"Price" must be a number';
         }
         else if(TokenPrice == 0) {
           ValidateError.TokenPrice = '"Price" must be greater than zero';
         }
       }
       if(biddingtoken==''){
        ValidateError.biddingtoken = '"Currency" Should be Selected';

      }
       if(PutOnSale == true && PutOnSaleType=='TimedAuction') {
         if(MinimumBid == '') {
           ValidateError.MinimumBid = '"Bid Price" must be a number';
         }
         if(parseFloat(MinimumBid)<= 0) {
           ValidateError.MinimumBid = '"Bid Price" must be Greater than Zero';
         }
       }
       if(typeof TokenCategory == 'undefined' || TokenCategory == '') {
         ValidateError.TokenCategory = '"Category" is required';
       }
 
       if(TokenQuantity == '' || isNaN(TokenQuantity) == true) {
         ValidateError.TokenQuantity = '"Number of copies" must be a number & greater than zero';
       }
       else if(TokenQuantity == 0) {
         ValidateError.TokenQuantity = '"Number of copies" must be greater than zero';
       } 
       if(Unlockoncepurchased == true && UnLockcontent!=null && UnLockcontent!=undefined && UnLockcontent!=""){

       }else if(Unlockoncepurchased == true ){
         ValidateError.UnLockcontent = 'Unlock content must be a Valid one';
       }
       setValidateError(ValidateError);
       return ValidateError;
     }
     else {
       return {};
     }
   }
 
   async function DateChange(from, val) {
     if(from == 'StartDateDropDown') {
       if(val == 'PickStartDate') {
         ModalAction('calendar_modal','show');
       }
       else {
         Set_StartDate('Right after listing');
       }
     }
     else if(from == 'EndDateDropDown') {
       if(val == 'PickEndDate') {
         ModalAction('calendar_modal_expire','show');
       }
       else {
         Set_EndDate(val);
         var myDate = new Date();
         var newdat = myDate.setDate(myDate.getDate() + parseInt(val));
         var newdate = new Date(newdat)
         set_EndClocktime(newdate)
       }
     }
   }

  //  async function ModalAction(id, type) {
  //   window.$('#'+id).modal(type);
  //   if(id=='calendar_modal') {
  //     console.log('ModalAction Clocktime', Clocktime);
  //     if(Clocktime) {
  //       var dt = new Date(Clocktime);
  //       var dt1 = dt.toLocaleString();
  //       Set_StartDate(dt1);
  //       var myDate = new Date(Clocktime);
  //       var newdat = myDate.setDate(myDate.getDate() + parseInt(EndDate));
  //       var newdate = new Date(newdat)
  //       set_EndClocktime(newdate)
  //     }
  //   }
  //   else if(id=='calendar_modal_expire') {
  //     console.log('ModalAction EndClocktime', EndClocktime);
  //     if(EndClocktime) {
  //       var dt = new Date(EndClocktime);
  //       var dt1 = dt.toLocaleString();
  //       Set_EndDate(dt1);
  //     }
  //   }
  // }
  
  async function ModalAction(id, type) {
    window.$('#'+id).modal(type);
    if(id=='calendar_modal') {
      if(Clocktime) {
        var dt = new Date(Clocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_StartDate(dt1);
      }
    }
    else if(id=='calendar_modal_expire') {
      if(EndClocktime) {
        var dt = new Date(EndClocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_EndDate(dt1);
      }
    }
  }
  const handlecreatecollectionSubmit = async (e) => {
     e.preventDefault();
     Set_FormSubmitUserClicked(false);
     var errors = await CreateCollectionValidation(true);
     var errorsSize = Object.keys(errors).length;
     console.log("collection_err",errorsSize)
     console.log("errrrrrrrr",errors)
 
     if(errorsSize != 0) {
       toast.error("Form validation error. Fix all mistakes and submit again", toasterOption);
       return false
     }
     else if (window.ethereum) {
       if (typeof window.web3 == 'undefined' || typeof window.web3.eth == 'undefined') {
         toast.error("Please Connect to Binance Network", toasterOption)
         Set_WalletConnected(false);
       }
       else {
         var currAddr = window.web3.eth.defaultAccount;
         window.web3.eth.getBalance(currAddr, async (errors, balance) => {
           var usercurbal = 0;
           if (typeof balance == 'undefined' || balance == null) {
             Set_UserAccountBal(0);
           }
           else {
             usercurbal = balance/config.decimalvalues;
             Set_UserAccountBal(usercurbal);
           }
           if(usercurbal == 0){
             toast.error("Insufficient balance", toasterOption);
             return false;
           }
 
           var dataTokenOwner = new FormData();
           var newConAddr = "";
           dataTokenOwner.append("collectionimage", CollectionFile);
           dataTokenOwner.append("Dispname", Dispname);
           dataTokenOwner.append("Symbol", Symbol);
           dataTokenOwner.append("Colsdescription", Colsdescription);
           dataTokenOwner.append("Shorturl", Shorturl);
           dataTokenOwner.append("owneraddr", currAddr);
           dataTokenOwner.append("type", CollectibleType);
           var web3 = new Web3(window.ethereum);
           window.web3.eth.getAccounts(async (error, result) => {
           var contract = await new web3.eth.Contract(userContract721)
             .deploy({
               data:
                 "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",
               arguments: [Dispname, Symbol], 
             })
             .send({ from: result[0] })
             .then(async function (newContractInstance) {
               newConAddr = newContractInstance.options.address; 
              setdigitalContract(newConAddr);
               dataTokenOwner.append("newConAddr", newConAddr);
               const res = await CreateCollectionValidationAction(dataTokenOwner);
               if (res.data && res.data.RespType) {
                 setnewCollectionStatus(1);
                 toast.success("BEP721 Collection Created Successfully", toasterOption);
                 document.getElementById("choose_collection_modal").click();
               }
 
             })
             .catch(function (error) {
               toast.error("Collection not Successfully", toasterOption);
               setCollectionStatus('tryagain');
             });
           })
         })
       }
 
     }else{
       toast.error("Please Connect to Binance Network", toasterOption);
       Set_WalletConnected(false);
     }
   }

   async function connectwallet() {
    toast.error("Please connect to a Metamask wallet", toasterOption);
       return false;
   }
 
   async function CreateItem() {
     Set_FormSubmitUserClicked(true);
     var connectwallet=localStorage.getItem("xdtitfnbolav");
     if(!connectwallet){
       toast.error("Please connect to a Metamask wallet", toasterOption);
       return false;
     }
     var errors = await CreateItemValidation(true);
     var errorsSize = Object.keys(errors).length;
 
     if(errorsSize != 0) {
       toast.error("Form validation error. Fix all mistakes and submit again", toasterOption);
       return false
     }
     else if (window.ethereum) {
       if (typeof window.web3 == 'undefined' || typeof window.web3.eth == 'undefined') {
         toast.error("Please Connect to Binance Network", toasterOption)
         Set_WalletConnected(false);
       }
       else {
         var currAddr = window.web3.eth.defaultAccount;
         window.web3.eth.getBalance(currAddr, async (errors, balance) => {
           var usercurbal = 0;
           if (typeof balance == 'undefined' || balance == null) {
             Set_UserAccountBal(0);
           }
           else {
             usercurbal = balance/config.decimalvalues;
             Set_UserAccountBal(usercurbal);
           }
           if(usercurbal == 0){
             toast.error("Insufficient balance", toasterOption);
             return false;
           }
           var TokenCategory_label = TokenCategory;
 
           let payload = {
             TokenName,
             TokenRoyalities,
             image: TokenFile,
             TokenCategory_label,
             PutOnSaleType,
             TokenPrice,
             biddingtoken
           }
           console.log("createTokenval payload:", payload)
           const resp = await CreateTokenValidationAction(payload);
           console.log('resp', resp);
           if(resp && resp.data) {
             if(resp.data.errors) {
               var errors = resp.data.errors;
               var errorsSize = Object.keys(errors).length;
               if(errorsSize != 0) {
                 setValidateError(errors);
                 toast.error("Form validation error. Fix all mistakes and submit again", toasterOption);
               }
               else {
                 setValidateError({});
                 window.$('#create_item_modal').modal('show');
               }
             }
           }
         })
       }
     }
     else {
       toast.error("Please Connect to Binance Network", toasterOption);
       Set_WalletConnected(false);
     }
   }
 
   const AfterWalletConnected = async () => {
     var currAddr = await getCurAddr();
     if(currAddr){
       GetCategoryCall();
       TokenCount_Get_Call();
     }
   }
 
   async function TokenCount_Get_Call() {
     var Resp = await TokenCount_Get_Action();
     if(Resp && Resp.data && Resp.data.tokenId) {
     }
   }
 
   var dateTimeValidation = (currentDate) => {
     return currentDate.isAfter(moment(new Date()));
   };
   const SelectBidcurrency = (e) => {
    set_biddingtoken(e.target.value)
    youWillPay(e.target.value, TokenPrice)
  }
  async function youWillPay(bid, amount) {
    try{
      var bidper;
      var provider = window.ethereum;
       var web3 = new Web3(provider);
      if(location_pathname=="create-single"){   
          var nftContract = new web3.eth.Contract(BEP721,ContractAddressUser);
          if(bid==config.currencySymbol){
            var fee = await nftContract.methods.getServiceFee().call();
          } else if(bid==config.tokenSymbol){
            var fee = await nftContract.methods.getValobitdxFee().call();
          }
          else{
            var fee = await nftContract.methods.getServiceFee().call();
          }
          
       }else{
        
        var nftContract = new web3.eth.Contract(BEP1155,ContractAddressUser);
        if(bid==config.currencySymbol){
          var fee = await nftContract.methods.getServiceFee().call();
        } else if(bid==config.tokenSymbol){
          var fee = await nftContract.methods.getValobitdxFee().call();
        }
        else{
          var fee = await nftContract.methods.getServiceFee().call();
        }
       }
       var bidper = fee/config.decimalvalues
        setservicefee(bidper)
      var youwill = (bidper / 100) * amount
      var finalwill = amount - youwill
      console.log("youwill_val:",bid,amount,bidper,finalwill)
      setTokenWill(finalwill)
    }catch(err){}
  }
  // async function youWillPay(bid, amount) {
  //   var bidper;
  //   var provider = window.ethereum;
  //    var web3 = new Web3(provider);
  //    console.log(ContractAddressUser,"==========ContractAddressUser")
  //   if(location_pathname=="create-single"){
  //     var nftContract = new web3.eth.Contract(BEP721,ContractAddressUser);
  //    }else{
  //     var nftContract = new web3.eth.Contract(BEP1155,ContractAddressUser);
  //    }
  //    var fee = await nftContract.methods.getServiceFee().call();
  //    console.log(fee,"==============you will")
  //   if (bid == config.currencySymbol) {
  //     bidper = fee/config.decimalvalues
  //   } 
  //   else if (bid==config.tokenSymbol){
  //     bidper = fee/config.decimalvalues
  //   }else if (bid==config.qualTokenSymbol){
  //     bidper = fee/config.decimalvalues
  //   }
  //   else {
  //     bidper = fee/config.decimalvalues
  //   }
  //   var youwill = (bidper / 100) * amount
  //   var finalwill = amount - youwill
  //   setTokenWill(finalwill)
  // }

    const { classes, theme } = props;
    // const open = Boolean(anchorEl);    
    return (
      <div className={classes.root}>
         <ConnectWallet
          Set_UserAccountAddr={Set_UserAccountAddr}
          Set_UserAccountBal={Set_UserAccountBal}
          Set_WalletConnected={Set_WalletConnected}
          Set_AddressUserDetails={Set_AddressUserDetails}
          Set_Accounts={Set_Accounts}
          WalletConnected={WalletConnected}
          AfterWalletConnected={AfterWalletConnected}
      />
        <ScrollToTopOnMount/>
        <CssBaseline />
        
        {/* Header APP */}
        <HeaderDashboard 
          classes={classes}
          handleDrawerOpen={handleDrawerOpen}
          open={open}
          handleMenu={handleMenu}
          handleClose={handleClose}
          anchorEl={anchorEl}
        />
        
       {/*  side Menu */}
        <SidebarLinksAfterlogin classes1={classes} open={open}/>
        <div className="overlay"></div>
        <main className={classes.content + " dashContent"}>
          <div className={classes.toolbar} />
          <div className="dashPages">              
            <GridContainer>              
              <GridItem xs={12} sm={12} md={9} className="m-auto">
                <div class="d-flex align-items-center">
                  <Link class="goback_link" to="/create">
                    <i class="bi bi-chevron-left"></i><span>Go back</span>
                  </Link>
                </div>
                <div>
                {(CollectibleType == 721) ?
                  <h2 className="inner_title text-center">Create Single  NFT</h2>
                  :
                  <h2 className="inner_title text-center">Create Multiple NFT</h2>
                }
                  <div className="container">
                    <GridContainer>
                      <GridItem xs={12} sm={4} md={4}>
                        <label className="primary_label">Preview</label>
                        <div className="single_collectible">
                          <div className="item">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="masonry_likes">
                                <i className="fas fa-heart mr-2"></i>
                                <span>0</span>
                              </div>                              
                            </div>
                            
                            {
                                (TokenFilePreUrl.split('.').pop() == 'mp4')
                                ?
                                  <video id="imgPreview" src={TokenFilePreReader != "" ? TokenFilePreReader : `${config.Back_URL}/images/noimage.png`} type='video/mp4' alt="Collection" className="img-fluid" autoPlay playsInLine loop muted></video>
                                :
                                <div className="text-center">
                                {(TokenFilePreUrl.split('.').pop() == 'mp3') ?
                                <div>
                                <img src={config.Back_URL+"/images/music.png"} id="imgPreview" alt="Collections" className="img-fluid" />
                                </div>
                                :
                                  <img src={TokenFilePreReader != "" ? TokenFilePreReader : `${config.Back_URL}/images/noimage.png`} id="imgPreview" alt="Collections" className="img-fluid" />
                                }
                                </div>
                              }
                          <h2>{TokenName}</h2>
                            <div className="d-flex justify-content-between align-items-end">
                              <div>
                                <h3>
                                {(PutOnSale == true && PutOnSaleType=='FixedPrice') &&
                                  <span>{TokenPrice} {biddingtoken}   </span>
                                }
                                {(PutOnSale == true && PutOnSaleType=='TimedAuction') &&
                                  <span>{MinimumBid} {biddingtoken}   </span>
                                }

                                   {TokenQuantity} of {TokenQuantity}</h3>
                                <h4> 
                                {( (PutOnSale == true && PutOnSaleType=='FixedPrice' && TokenPrice > 0)) &&
                                    <span>Place a Bid</span>
                                  } 
                                    {(PutOnSale == false || (PutOnSale == true && PutOnSaleType=='FixedPrice' && TokenPrice == 0)) && <span>Not for sale </span>}
                                    {(PutOnSale == true && PutOnSaleType=='TimedAuction') && <span>Minimum Bid </span>}
                                    {(PutOnSale == true && PutOnSaleType=='UnLimitedAuction') && <span>Open for Bids </span>}
                              {(PutOnSale == true && !PutOnSaleType=='UnLimitedAuction') &&
                                <span>{usdval*TokenPrice} USD</span>
                              }
                                </h4>
                              
                              </div>
                              <div className="d-flex creators_details">
                                <img src={require("../assets/images/user_01.png")} alt="User" className="img-fluid" />
                                <img src={require("../assets/images/user_02.png")} alt="User" className="img-fluid" />
                                <img src={require("../assets/images/user_03.png")} alt="User" className="img-fluid" />
                              </div>
                              
                            </div>
                            <div className="audio_prev">
                            {(TokenFilePreUrl.split('.').pop() == 'mp3') ?
                                <audio src={TokenFilePreReader != "" ? TokenFilePreReader : `${config.Back_URL}/images/noimage.png`} type="audio/mp3"controls className="audio">
                                </audio>:""
                              }
                            </div>
                          </div>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={8} md={8}>
                        <form>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <div className="d-flex justify-content-between align-items-start">
                                  <div>
                                    <label className="primary_label" htmlFor="inputEmail4">Upload file</label>
                                    <p className="form_note">PNG, GIF, WEBP, MP4 or MP3. Max 30mb.</p>
                                    {ValidateError.TokenFilePreUrl && <span className="text-danger">{ValidateError.TokenFilePreUrl}</span>}
                                  </div>
                                  <div className="file_btn primary_btn">Upload
                                    <input className="inp_file" type="file" name="file"  onChange={selectFileChange}/>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <label className="primary_label" htmlFor="inputEmail4">Put on Sale</label>
                                  <p className="form_note">You’ll receive bids on this item</p>
                                </div>
                                <label className="switch toggle_custom">
                                  <input type="checkbox"
                                   id="putonsale"
                                   name="putonsale"
                                   onChange={CheckedChange}
                                   checked={PutOnSale}/>
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <label className="primary_label" htmlFor="inputEmail4">Unlock Once Purchased</label>
                                  <p className="form_note">Content will be unlocked after<br/> successful transaction</p>
                                </div>
                                <label className="switch toggle_custom">
                                  <input type="checkbox"
                                  id="unlockoncepurchased"
                                  name="unlockoncepurchased"
                                  onChange={CheckedChange}
                                  />
                                  <span className="slider"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          {/*<div className="form-row">
                            <div className="form-group col-md-12">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div>
                                    <label className="primary_label" htmlFor="inputEmail4">Choose Collection</label>
                                  </div>
                                  <Button className="primary_btn" data-toggle="modal" data-target="#choose_collection_modal">Create BEP 721</Button>
                              </div>
                            </div>
                          </div>
                           <div className="form-row">
                            <div className="form-group col-md-12">
                              <div className="d-flex justify-content-between align-items-start">
                                <div>
                                  <label className="primary_label" htmlFor="inputEmail4">Instant on Sale</label>
                                </div>
                                <label className="switch toggle_custom">
                                  <input type="checkbox"/>
                                  <span className="slider"></span>
                                </label>
                              </div>
                              <p className="form_note pr-5 mt-2">Enter the price for which the item will be instantly sold</p>
                            </div>
                          </div> */}
                          <div className="form-row">
                            <div className="form-group col-md-12">
                            {
                (PutOnSale==false)?(''):(
                              <div className="d-flex justify-content-start align-items-start">
                                {/* <Button className="nft_create_btn active">Fixed Price</Button>
                                <Button className="nft_create_btn">Timed Auction</Button>
                                <Button className="nft_create_btn">Ongoing Auction</Button> */}
                                <Button 
                                  onClick={()=>{changePutOnSaleType('FixedPrice')}} 
                                  className={"nft_create_btn mr-2 " + ((PutOnSaleType=='FixedPrice')?'active':'inactive')}
                                >
                                  Fixed Price
                                </Button>
                                {(CollectibleType == 721) &&
                                  <Button 
                                    onClick={()=>{changePutOnSaleType('TimedAuction')}}
                                    className={"nft_create_btn mr-2 " + ((PutOnSaleType=='TimedAuction')?'active':'inactive')}
                                  >
                                    Timed Auction
                                  </Button>
                                }
                                <Button
                                  onClick={()=>{changePutOnSaleType('UnLimitedAuction')}} 
                                  className={"nft_create_btn mr-2 " + ((PutOnSaleType=='UnLimitedAuction')?'active':'inactive')}
                                >
                                  Ongoing Auction
                                </Button>
                              </div>
                )}
                                {/* <div>
                                  <label className="primary_label" htmlFor="inputEmail4">Instant Sale Price</label>
                                  <p className="form_note">Enter the price for which the item<br/> will be instantly sold</p>
                                </div>
                                <label className="switch toggle_custom">
                                  <input type="checkbox"/>
                                  <span className="slider"></span>
                                </label> */}
                            </div>
                          </div>
                          {
                         (Unlockoncepurchased) &&
                         <>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <input type="text" className="primary_inp" 
                                name="UnLockcontent"
                                id="UnLockcontent"
                                onChange={inputChange}
                                placeholder="Digital key code or link"/>
                              <p className="form_note">Tip: Markdown syntax is supported</p>
                            </div>
                          </div>
                        {ValidateError.UnLockcontent && 
                          <span className="text-danger">{ValidateError.UnLockcontent}</span>
                        }
                      </>
                        }

                          {(PutOnSale==true && PutOnSaleType == 'FixedPrice')&&
                          <div className="form-row">
                            <div className="form-group col-md-6">
                              <label className="primary_label" htmlFor="name">Price</label>
                              <input type="number" 
                              onKeyDown={(evt) => ["e", "E", "+", "-",","].includes(evt.key) && evt.preventDefault()} 
                              className="primary_inp" autoComplete="off" id="TokenPrice" name="TokenPrice" onChange={inputChange}
                              placeholder="Enter the price of one piece" min="0"/>
                                    {ValidateError.TokenPrice && <span className="text-danger">{ValidateError.TokenPrice}</span>}
                            </div>
                            <div className="form-group col-md-6">
                              <label className="primary_label">&nbsp;</label>
                            <select class="d-block custom-select select_menu primary_inp" id="TokenCategory1" name="TokenCategory" onChange={SelectBidcurrency}  >
                                  {/*<option value={config.tokenSymbol} selected>{config.tokenSymbol}</option>*/}
                                      {
                                        price.map((item) => {
                                          return (
                                          <option  value={item.label} >{item.label}</option>
                                          )
                                        })
                                      }
                                </select>  
                                {ValidateError.biddingtoken && <span className="text-danger">{ValidateError.biddingtoken}</span>}
                              </div>
                            <div className="inbut_reason_tetx">
                        {(biddingtoken && biddingtoken == config.currencySymbol) ?
                          <p>Service fee <span>{servicefee} %</span></p>
                          :
                          <p>Service fee <span>{servicefee} %</span></p>
                        }
                        <p>You will receive  <span>{tokenWill.toFixed(config.toFixed)} {biddingtoken}</span></p>
                      </div>
                          </div>
                        }
                      {(PutOnSale==true && PutOnSaleType == 'TimedAuction')&&
                          <div className="form-row">
                          <div className="form-group col-md-6">
                            <label className="primary_label" htmlFor="name">Minimum bid</label>
                            <input type="number" onKeyDown={(evt) => ["e", "E", "+", "-",","].includes(evt.key) && evt.preventDefault()} className="primary_inp" autoComplete="off" id="MinimumBid" name="MinimumBid" onChange={inputChange}
                             placeholder="Enter minimum bid" min="0"/>
                    {ValidateError.MinimumBid && <span className="text-danger">{ValidateError.MinimumBid}</span>}
                          </div>
                          <div className="form-group col-md-6">
                            <label className="primary_label">&nbsp;</label>
                          <select class="d-block custom-select select_menu primary_inp" id="TokenCategory1" name="TokenCategory" onChange={SelectBidcurrency}  >
                                {
                                 bidprice.map((item) => {
                                   return (
                                   <option  value={item.label} >{item.label}</option>
                                   )
                                 })
                               }
                              </select>  
                              {ValidateError.biddingtoken && <span className="text-danger">{ValidateError.biddingtoken}</span>}
                            </div>
                          </div>
                    }
                     {/* {(PutOnSale==true && PutOnSaleType == 'UnLimitedAuction')&&
                          <div className="form-row">
                          <div className="form-group col-md-6">
                            <label className="primary_label">&nbsp;</label>
                          <select class="d-block custom-select select_menu primary_inp" id="TokenCategory1" name="TokenCategory" onChange={SelectBidcurrency}  >
                                {
                                 bidprice.map((item) => {
                                   return (
                                   <option  value={item.label} >{item.label}</option>
                                   )
                                 })
                               }
                              </select>  
                              {ValidateError.biddingtoken && <span className="text-danger">{ValidateError.biddingtoken}</span>}
                            </div>
                          </div>
                    } */}
                    {(PutOnSale==true && PutOnSaleType == 'TimedAuction')&&
                          <div className="form-row">
                            <div className="col-md-12">
                              <div className="form-row">
                                <div className="form-group col-md-6">
                                  <label className="primary_label" htmlFor="minimumbid">Starting Date</label>
                                  <div class="dropdown">
                                      <button class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span id="menuBut">{StartDate}</span>
                                      </button>
                                      <div class="dropdown-menu filter_menu" aria-labelledby="dropdownMenuButton">
                                        <div id="RightAfterListing" onClick={()=>{DateChange('StartDateDropDown','RightAfterListing')}} >Right after listing</div>
                                        <div id="PickStart" onClick={()=>{DateChange('StartDateDropDown','PickStartDate')}} >Pick specific date</div>
                                      </div>
                                    </div>
                                    {ValidateError.StartDate && <span className="text-danger">{ValidateError.StartDate}</span>}
                                  {/* <DatePicker className="primary_inp" selected={startDate} onChange={(date) => setStartDate(date)} selectsStart dateFormat="dd/MM/yyyy h:mm aa" showTimeInput/> */}
                                </div>
                                

                                <div className="form-group col-md-6">
                                  <label className="primary_label" htmlFor="minimumbid">Expiration Date</label>
                                  <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <span id="menuBut">{EndDate}</span>
                                </button>
                                <div class="dropdown-menu filter_menu" aria-labelledby="dropdownMenuButton">
                                  <div onClick={()=>{DateChange('EndDateDropDown','1 Day')}} >1 Day</div>
                                  <div onClick={()=>{DateChange('EndDateDropDown','3 Day')}} >3 Day</div>
                                  <div onClick={()=>{DateChange('EndDateDropDown','5 Day')}} >5 Day</div>
                                  <div onClick={()=>{DateChange('EndDateDropDown','7 Day')}} >7 Day</div>
                                  <div onClick={()=>{DateChange('EndDateDropDown','PickEndDate')}} >Pick specific date</div>
                                  
                                </div>
                                </div>
                                {ValidateError.EndDate && <span className="text-danger">{ValidateError.EndDate}</span>}

                                 {/* <DatePicker className="primary_inp" selected={endDate} onChange={(date) => setEndDate(date)} selectsEnd  minDate={startDate} dateFormat="dd/MM/yyyy h:mm aa" showTimeInput/> */}
                                </div>
                              </div>
                            </div>

                          </div> 
                  }
                
<div class="modal fade primary_modal" id="calendar_modal" tabindex="-1" role="dialog" aria-labelledby="calendar_modalCenteredLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                      <div class="modal-content">
                        <div class="modal-module">
                          <div class="modal-header text-center">
                            <h5 class="modal-title" id="calendar_modalLabel">Choose date</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="cancelcalender">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div className="pb-3">
                              <Datetime
                                minDate={new Date().getTime()}
                                input={false}
                                value={Clocktime}
                                onChange={(value) => set_Clocktime(value)}
                              />
                            </div>
                          </div>
                          <div class="text-center mb-3">
                            <Button className="primary_btn" id="doneStartDate" onClick={() => ModalAction('calendar_modal','hide')}>Done</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal fade primary_modal" id="calendar_modal_expire" tabindex="-1" role="dialog" aria-labelledby="calendar_modalCenteredLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                      <div class="modal-content">
                        <div class="modal-module">
                          <div class="modal-header text-center">
                            <h5 class="modal-title" id="calendar_modalLabel">Choose date</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="cancelcalender">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div className="pb-3">
                              <Datetime
                                input={false}
                                value={EndClocktime}
                                minDate={new Date().getTime()}
                                onChange={(value) => set_EndClocktime(value)}
                              />
                            </div>
                          </div>
                          <div class="text-center mb-3">
                            <Button className="primary_btn" id="doneEndDate" onClick={() => ModalAction('calendar_modal_expire','hide')}>Done</Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <label className="primary_label" htmlFor="name">Name</label>
                              <input type="text" className="primary_inp" id="TokenName"
                                name="TokenName" onChange={inputChange}
                                placeholder="e.g. Redeemable"  autoComplete="off"
                                />
                            </div>
                            {ValidateError.TokenName && <span className="text-danger">{ValidateError.TokenName}</span>}
                          </div>
                          <div  className="form-row">
                            <div className="form-group col-md-12">
                              <label className="primary_label" htmlFor="desccription">Description <span className="text-muted">(Optional)</span></label>
                              <input type="text" className="primary_inp" id="TokenDescription" name="TokenDescription" 
                                onChange={inputChange} placeholder="e.g. After purchasing..."/>
                            </div>
                          </div>
                          <div className="form-row">
                            <div className="form-group col-md-12">
                              <label className="primary_label" htmlFor="name">Royalties</label>
                              <div className="inp_grp">
                                <input type="number" className="primary_inp" min="1" max="50"
                                 id="TokenRoyalities" name="TokenRoyalities" onKeyDown={(evt) => ["e", "E", "+", "-",".",","].includes(evt.key) && evt.preventDefault()}
                                 onChange={inputChange} autoComplete="off" placeholder="1" value={TokenRoyalities}/>
                                <p className="inp_append">%</p>
                                <span className="text-muted">Suggested:( 0%, 10%, 20%, 30%. Maximum is 50%)</span>
                              </div>
                              {ValidateError.TokenRoyalities && <span className="text-danger"><br/>{ValidateError.TokenRoyalities}</span>}
                            </div>                           
                          </div>
                          {(location_pathname=="create-multiple")&&
                          <div className="form-row">                            
                            <div className="form-group col-md-12">
                              <label className="primary_label" htmlFor="desccription">Quantity <span className="text-muted"></span></label>
                              <input type="text" className="primary_inp" id="TokenQuantity"
                               onChange={location_pathname =="create-single"?"": inputChange}
                               value={TokenQuantity} 
                               onKeyDown={(evt) => ["e", "E", "+", "-","."].includes(evt.key) && evt.preventDefault()}
                               name="TokenQuantity" placeholder="e.g. size"
                               disabled={location_pathname =="create-single"?true:false}
                               />
                            </div>
                            {ValidateError.TokenQuantity && <span className="text-danger"><br/>{ValidateError.TokenQuantity}</span>}
                          </div>
                            }

                          <div className="form-row">                            
                            <div className="form-group col-md-12">
                              <label className="primary_label" htmlFor="desccription">Properties <span className="text-muted">(Optional)</span></label>
                              <input type="text" className="primary_inp" id="TokenProperties" name="TokenProperties" 
                              onChange={inputChange}
                              placeholder="e.g. size"
                              autoComplete="off"/>
                            </div>
                          </div>
                          <div className="form-row">                            
                            <div className="form-group col-md-6">
                              <label className="primary_label" htmlFor="desccription">Category</label>
                              <select class="custom-select select_menu primary_inp" id="TokenCategory" name="TokenCategory" onChange={handleChange}  >
                            <option value="" >Select Category </option>
                                {
                                  Categorylist.map((item) => {
                                    return (
                                    <option  value={item._id} >{item.name}</option>
                                    )
                                  })
                                }
                          </select>  
                    {ValidateError.TokenCategory && <span className="text-danger"><br/>{ValidateError.TokenCategory}</span>}

                            </div>
                          </div>


                          {/* <div className="form-row">
                        <div className="form-group col-md-12">
                          <label className="primary_label" htmlFor="inputEmail4">Category</label>
                            <select class="custom-select select_menu " id="TokenCategory" onChange={handleChange} name="TokenCategory" >
                            <option value="All" >All</option>
                                {
                                  Categorylist.map((item) => {
                                    return (
                                    <option  value={item.name} >{item.name}</option>
                                    )
                                  })
                                }
                          </select>  
                  </div>
                  </div> */}
                      
                          <div>
                            <Button type="button" className="primary_btn" 
                            // data-toggle="modal"
                            //  data-target="#create_item_modal"
                            onClick={localStorage.getItem("xdtitfnbolav") ? CreateItem:connectwallet}
                             >{localStorage.getItem("xdtitfnbolav") && whitelist ?"Create item":!localStorage.getItem("xdtitfnbolav")?"Connect Wallet":"WhiteList User Only able to Create"}</Button>
                          </div>
                        </form>
                      </GridItem>
                    </GridContainer>
                  </div>
                </div>
              </GridItem>             
            </GridContainer>
          </div>
        </main>
        
        <WalletModal/>       

      {/* Choose Collection Modal */}
      <div class="modal fade primary_modal" id="choose_collection_modal" tabindex="-1" role="dialog" aria-labelledby="choose_collection_modalCenteredLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header text-center">
              <h5 class="modal-title" id="choose_collection_modalLabel">Collection</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="d-flex align-items-center">
                <div class="hex center">
                  <div class="hex__shape">
                    <div class="hex__shape">
                      <div class="hex__shape">
                        <img src={require("../assets/images/img_02.jpg")} alt="logo" className="img-fluid"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="font_16 font_600 line_20 mb-1">We recommend an image of at least 400x400. Gifs work too.</p>
                  <div className="file_btn primary_btn d-inline-block">Choose File
                    <input className="inp_file" type="file" name="file"/>
                  </div>
                </div>
              </div>
              <form>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label className="primary_label" htmlFor="name">Display Name <span className="text-muted">(30 available)</span></label>
                    <input type="text" className="form-control primary_inp" id="name" placeholder="Enter token name"/>
                  </div>
                  <div className="form-group col-md-12">
                    <label className="primary_label" htmlFor="desccription">Symbol <span className="text-muted">(required)</span></label>
                    <input type="text" className="form-control primary_inp" id="desccription" placeholder="Enter token symbol"/>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label className="primary_label" htmlFor="name">Description <span className="text-muted">(Optional)</span></label>
                    <input type="text" className="form-control primary_inp" id="name" placeholder="Spread some words about token collection"/>                  
                  </div>
                  <div className="form-group col-md-12">
                    <label className="primary_label" htmlFor="desccription">Short url</label>
                    <input type="text" className="form-control primary_inp" id="desccription" defaultValue="spideybarter.io/"/>
                  </div>
                </div>
                <div className="text-center">
                  <Button className="create_btn">Create Collection</Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Create Item Modal */}
      <div class="modal fade primary_modal" id="create_item_modal" tabindex="-1" data-backdrop="static" role="dialog" aria-labelledby="create_item_modalCenteredLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header text-center">
              <h5 class="modal-title" id="create_item_modalLabel">Follow Steps</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">                         
              <form> 
              <div className="media approve_media">
              {ApproveCallStatus=='processing' ? 
              <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >
              :
              ApproveCallStatus=="done"?
              <i className="fas fa-check mr-3 pro_complete" aria-hidden="true"></i>
              :
              <i className="fas fa-check mr-3" aria-hidden="true"></i>
              }
              {/* <i class="fa fa-spinner mr-3 spinner_icon"  approve_desc aria-hidden="true"></i> */}
              <div className="media-body">
                <p className="mt-0 approve_text">Approve</p> 
                <p className="mt-0 approve_desc">Approve performing transactions with your wallet</p>
              </div>
            </div>
              <div className="text-center my-3">
              {/* <Button className="btn_outline_red btn-block">Done</Button> */}
              <Button
                    className="btn_outline_red btn-block"
                    disabled={(ApproveCallStatus=='processing' || ApproveCallStatus=='done')}
                    onClick={ApproveCall}
                  >
                    {ApproveCallStatus == 'processing' && <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >}
                    {ApproveCallStatus == 'init' && 'Start'}
                    {ApproveCallStatus == 'processing' && 'In-progress...'}
                    {ApproveCallStatus == 'done' && 'Done'}
                    {ApproveCallStatus == 'tryagain' && 'Try Again'}
                  </Button>                
              </div>
              <div className="media approve_media">
              {MintCallStatus=='processing' ?
                <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >
              :
              MintCallStatus=='done'?
              <i className="fas fa-check mr-3 pro_complete" aria-hidden="true"></i>
              :
              <i className="fas fa-check mr-3" aria-hidden="true"></i>
              }
              <div className="media-body">
                <p className="mt-0 approve_text">Upload files & Mint token</p> 
                <p className="mt-0 approve_desc">Call contract method</p>
              </div>
            </div>
              <div className="text-center my-3">
              {/* <Button className="create_btn btn-block">Start</Button>      
                         */}
                <Button
                    className="btn_outline_red btn-block" 
                    disabled={(ApproveCallStatus!='done' || MintCallStatus=='processing' || MintCallStatus=='done')}
                    onClick={MintCall}
                  >
                    {MintCallStatus == 'processing' && <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >}
                    {MintCallStatus == 'init' && 'Start'}
                    {MintCallStatus == 'processing' && 'In-progress...'}
                    {MintCallStatus == 'done' && 'Done'}
                    {MintCallStatus == 'tryagain' && 'Try Again'}
                  </Button>
              </div>

              <div className="media approve_media">
              {SignCallStatus=='processing' ?
              <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >
              :
              SignCallStatus=='done'?
              <i className="fas fa-check mr-3 pro_complete" aria-hidden="true"></i>
              :
              <i className="fas fa-check mr-3" aria-hidden="true"></i>
              }
              <div className="media-body">
                <p className="mt-0 approve_text">Sign sell order</p> 
                <p className="mt-0 approve_desc">Sign sell order using your wallet</p>
              </div>
            </div>
              <div className="text-center my-3">
              {/* <Button className="create_btn btn-block" disabled>Start</Button>      
                         */}
               <Button
                    className="btn_outline_red btn-block"
                    disabled={(MintCallStatus!='done' || SignCallStatus=='processing' || SignCallStatus=='done')}
                    onClick={SignCall}
                  >
                    {SignCallStatus == 'processing' && <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >}
                    {SignCallStatus == 'init' && 'Start'}
                    {SignCallStatus == 'processing' && 'In-progress...'}
                    {SignCallStatus == 'done' && 'Done'}
                    {SignCallStatus == 'tryagain' && 'Try Again'}
                  </Button>
              </div>

              <div className="media approve_media">
              {SignLockCallStatus=='processing' ? 
              <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >
              :
              SignLockCallStatus=='done'?
              <i className="fas fa-check mr-3 pro_complete" aria-hidden="true"></i>
              :
              <i className="fas fa-check mr-3" aria-hidden="true"></i>
            }
              <div className="media-body">
                <p className="mt-0 approve_text">Sign lock order</p> 
                <p className="mt-0 approve_desc">Sign lock order using your wallet</p>
              </div>
            </div>
              <div className="text-center mt-3">
              {/* <Button className="create_btn btn-block" disabled>Start</Button>   
                            */}
                <Button
                    className="btn_outline_red btn-block"
                    disabled={(SignCallStatus!='done' || SignLockCallStatus=='processing' || SignLockCallStatus=='done')}
                    onClick={SignLockCall}
                  >
                    {SignLockCallStatus == 'processing' && <i class="fa fa-spinner mr-3 spinner_icon" aria-hidden="true" id="circle1"></i >}
                    {SignLockCallStatus == 'init' && 'Start'}
                    {SignLockCallStatus == 'processing' && 'In-progress...'}
                    {SignLockCallStatus == 'done' && 'Done'}
                    {SignLockCallStatus == 'tryagain' && 'Try Again'}
                  </Button>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      </div>
    );
}

CreateSingle.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(CreateSingle);
